import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'times',
  standalone: false,
})
export class TimesPipe implements PipeTransform {
  transform(value) {
    if (value) return new Array(value).fill(1);
  }
}
